import { Component, Input } from '@angular/core';
import { PreviewDevice, PreviewDevices } from '@empathy/survey/base';

@Component({
  selector: 'empathy-device-wrapper',
  templateUrl: 'device-wrapper.component.html',
  styleUrls: ['./device-wrapper.component.scss']
})
export class DeviceWrapperComponent {
  @Input() activeDevice: PreviewDevice;

  previewDevice = PreviewDevice;
  previewDevices = PreviewDevices;
}
